import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { convertPreVisitFormData } from '../utils/preVisitForm';
import SurveyListItem from '../SurveyListItem';
import SequentialSurveyPopup from '../../SequentialSurveyPopup';
import getSpecification from '../../../utils/survey/getSpecification';
import WithLazyLoad from '../../../hocs/withLazyLoad';
import { ACTIONS } from '../../../constants/strings';
import { enhance } from './enhance';

const SurveyList = ({
  formatMessage,
  surveys,
  loadMore,
  listTitle,
  upcomingListCounter,
  className,
}) => {
  const [assignmentId, setAssignmentId] = useState(null);

  return (
    <Fragment>
      <WithLazyLoad loadMore={loadMore}>
        <div className={className}>
          <If condition={Boolean(listTitle)}>
            <span styleName="title">{listTitle}</span>
            <span styleName="subtitle">
              {formatMessage(ACTIONS.survey.countSurveys, {
                count: upcomingListCounter,
              })}
            </span>
          </If>
          {surveys.map(item => {
            const { description, name, status, heading } = getSpecification(
              item,
              formatMessage,
            );
            const itemAssignmentId = get(item, 'assignmentId');
            const userAppointment = get(item, 'userAppointment');
            const list = convertPreVisitFormData(
              formatMessage,
              userAppointment,
            );

            return (
              <SurveyListItem
                key={itemAssignmentId}
                heading={heading}
                title={name}
                status={status}
                description={description}
                list={list}
                onClick={() => setAssignmentId(itemAssignmentId)}
              />
            );
          })}
        </div>
      </WithLazyLoad>
      <SequentialSurveyPopup
        assignmentId={assignmentId}
        onClose={() => setAssignmentId(null)}
      />
    </Fragment>
  );
};

SurveyList.defaultProps = {
  surveys: [],
};

SurveyList.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  surveys: PropTypes.arrayOf(PropTypes.object),
  loadMore: PropTypes.func,
  listTitle: PropTypes.string,
  upcomingListCounter: PropTypes.number,
  className: PropTypes.string,
};

export default enhance(SurveyList);



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveyList/index.jsx